// extracted by mini-css-extract-plugin
module.exports = {"alignnone":"PostBody_alignnone__EMbvI","aligncenter":"PostBody_aligncenter__hYeM4","alignleft":"PostBody_alignleft__upX_K","alignright":"PostBody_alignright__L7n3s"};